
/**
 * @nullable
 */
export type CreateNotificationBodyContentData = {[key: string]: unknown} | null;
